import React, { useState } from 'react'

import Env from '../../shared/config/envConfig'
import Button from '../../shared/components/FormComponents/ButtonComponent'
import TextField from '../../shared/components/FormComponents/TextFieldComponent'
import Switch from '../../shared/components/FormComponents/SwitchComponent'
import Rating from '../../shared/components/FormComponents/RatingComponent'
import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import { Stack, Typography, useTheme, Theme, Box } from '@mui/material'

export interface Props {
  reloadFeedback: ()=>void
}
const FeedbackForm: React.FC<Props> = (props) => {
  const theme: Theme = useTheme()
  const [publicFeedback, setPublicFeedback] = useState<boolean>(false)
  const [content, setContent] = useState<string>('')
  const [rating, setRating] = useState<number>(5)
  const [name, setName] = useState<string>('')

  const onSendFeedbackForm = () => {
    const feedbackPostRequest = {
      createdAt: new Date(),
      content,
      rating,
      name,
      public: publicFeedback,
    }
    const basePath = Env.basePath
    const restUrl = `${basePath}/api/feedback`

    const requestHeaders: HeadersInit = new Headers()
    requestHeaders.set('Accept', 'application/json')
    requestHeaders.set('Content-Type', 'application/json')

    fetch(restUrl, {
      method: 'POST',
      body: JSON.stringify(feedbackPostRequest),
      credentials: 'include',
      headers: requestHeaders,
    })
      .then((res) => res.json())
      .then((json) => {
        setPublicFeedback(false)
        setContent('')
        setRating(5)
        setName('')
        // reload Data
        props.reloadFeedback()
      })
      .catch((err) => console.log(err))
  }

  return (
    <>
      <Stack
        direction={{ xs: 'column' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        sx={{
          padding: theme.spacing(1),
          textAlign: 'center',
        }}
      >
        <Typography variant='h1'>Bewerte unsere Seite</Typography>
        <Box sx={{ width: 'auto' }}>
          <Rating
            filledIcon={<FavoriteIcon />}
            emptyIcon={<FavoriteBorderIcon />}
            value={rating}
            size='large'
            onChange={(_, value) => {
              setRating(value || 0)
            }}
          />
        </Box>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
        >
          <Box sx={{ width: '300px' }}>
            <TextField
              fullWidth
              label='Dein Name'
              onChange={(event) => {
                setName(event.target.value)
              }}
            />
          </Box>
          <Switch
            checked={publicFeedback}
            onChange={(checked) => setPublicFeedback(checked)}
            label='Anonym bewerten'
          />
        </Stack>
        <Stack
          sx={{ padding: '20px 0' }}
        >
          <TextField
            label='Schreibe uns, was dir gefällt oder was nicht...'
            multiline
            fullWidth
            minRows={5}
            onChange={(event) => {
              setContent(event.target.value)
            }}
          />
        </Stack>
        <Box sx={{ width: '300px' }}>
          <Button
            fullWidth
            onClick={(event) => {
              onSendFeedbackForm()
            }}
          >
            Bewertung absenden
          </Button>
        </Box>
      </Stack>
    </>
  )
}

export default FeedbackForm
